import { render } from "./ConfigView.vue?vue&type=template&id=79b9a606&scoped=true"
import script from "./ConfigView.vue?vue&type=script&lang=js"
export * from "./ConfigView.vue?vue&type=script&lang=js"

import "./ConfigView.vue?vue&type=style&index=0&id=79b9a606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b9a606"]])

export default __exports__